import { render, staticRenderFns } from "./Authorize.vue?vue&type=template&id=79c2042c&scoped=true&"
import script from "./Authorize.vue?vue&type=script&lang=ts&"
export * from "./Authorize.vue?vue&type=script&lang=ts&"
import style0 from "./Authorize.vue?vue&type=style&index=0&id=79c2042c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c2042c",
  null
  
)

export default component.exports